import { storeToRefs } from "pinia";
import { useSurveysStore } from "@stores/surveys";
import { useMCampaignStore } from "@stores/mCampaign";
import { useMCreativesStore } from "@stores/mCreatives";
import { useMMediumUploadsStore } from "@stores/mMediumUploads";
import { useMTemplatesStore } from "@stores/mTemplates";

export const useCreativesDependencies = () => {
  const surveysStore = useSurveysStore();
  const { lightSurvey } = storeToRefs(surveysStore);
  const { currentMCampaign } = storeToRefs(useMCampaignStore());
  const { fetchMMediumUploadsCampaign } = useMMediumUploadsStore();
  const { loadAdSetVariables } = useMCreativesStore();
  const mTemplatesStore = useMTemplatesStore();
  const { mTemplates } = storeToRefs(mTemplatesStore);

  const loadSurvey = async () => {
    const surveyId = currentMCampaign.value?.survey_id;
    if ("id" in lightSurvey.value && lightSurvey.value.id === surveyId) return true;
    return surveysStore.getSurveyLight(surveyId);
  };

  const loadTemplates = async () => mTemplates.value.length > 0 || mTemplatesStore.fetchMTemplates();

  const loadCreativeAssets = async () => {
    const results = await Promise.all([
      loadSurvey(),
      loadTemplates(),
      fetchMMediumUploadsCampaign(),
      loadAdSetVariables(),
    ]);
    return results.every(Boolean);
  };

  return { loadCreativeAssets };
};
